/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../../SharedModules/Table/tableGrid';
import TableFilterHeader from '../../../../contactType/components/TableFilterHeader';
import NDCColumnCustomComponent from '../../../../Display/NDC/component/NDCColumnCustomComponent';
import { NDC_DRUG_TABLEHAD } from '../../../../Display/NDC/utility/tableHeads';
import {
  searchClaimByNDCNu,
  setClaimDetailsTableRowSelected,
  setClaimErrorPopupMessage,
  setEditedRows,
  setNoOfUnitsSearchScreenObj,
} from '../../store/action';
import { handleScrollToEvent } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { getOverrideDefaultData } from '../../../RebateProgram/MaintainRebate/store/actions';
import CommonModal from '../../../../../SharedModules/Dialog/CommonModal';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';



const ClaimsDetailsTable = ({
  showFullScreen = true,
  fullScreen,
  setFullScreen,
  setError,
}) => {
  const dispatch = useDispatch();
  const claimDetailsTableData = useSelector(
    (state) => state.sharedState.NumberOfUnits.claimDetailsTableData
  );

  const claimSelectByFilter = useSelector(
    (state) => state.sharedState.NumberOfUnits.claimSelectByFilter
  );

  const invoiceSelected = useSelector(
    (state) => state.sharedState.NumberOfUnits.invoiceSelected
  );

  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const searchScreenReduxObj = useSelector(
    (state) => state.sharedState.NumberOfUnits?.searchScreenReduxObj
  );
   const claimCategoryCode = useSelector(
    (state) => state.sharedState.NumberOfUnits.claimCategoryCode
  );
  const childRef = useRef(null);
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [custPayload, setCustPayload] = React.useState();
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [tableCount, setTableCount] = useState(0);
  const [applyFilter, setApplyFilter] = useState(false);

  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };
  const checkCondition = () => {
    const errorMessages = new Set();
    const headerError = {};
    handleScrollToEvent();
    const paidQtr = claimSelectByFilter?.paidQtr?.trim();
    const processedQtr = claimSelectByFilter?.processedQtr?.trim();
    const invalidDateMessage =
      'Please enter a valid date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
    const isValidDateFormat = (value) => {
      const split = value.split('/');
      if (split.length === 2) {
        const [month, year] = split;

        return (
          month.length === 2 &&
          Number(month) >= 1 &&
          Number(month) <= 12 &&
          (year.length === 2 || year.length === 4)
        );
      }
      if (split.length === 3) {
        const [month, day, year] = split;
        return (
          month.length === 2 &&
          Number(month) >= 1 &&
          Number(month) <= 12 &&
          day.length === 2 &&
          Number(day) >= 1 &&
          Number(day) <= 31 &&
          (year.length === 2 || year.length === 4)
        );
      }

      return false;
    };
    const isValidQuarterFormat = (value) => {
      const split = value.split('Q');

      return (
        split.length === 2 &&
        ['1', '2', '3', '4'].includes(split[0]) &&
        (split[1].length === 2 || split[1].length === 4)
      );
    };
    if (!paidQtr) {
      errorMessages.add('A Paid date or quarter is required.');
      headerError.paidQtr = true;
    } else {
      const isDate =
        paidQtr.includes('/') && !paidQtr.includes('Q');
      const isQuarter =
        !paidQtr.includes('/') && paidQtr.includes('Q');
      const isValid =
        (isDate && isValidDateFormat(paidQtr)) ||
        (isQuarter && isValidQuarterFormat(paidQtr));
      if (!isValid) {
        errorMessages.add(invalidDateMessage);
        headerError.paidQtr = true;
      }
    }
    if (processedQtr) {
      const isValid = isValidQuarterFormat(processedQtr);

      if (!isValid) {
        errorMessages.add(invalidDateMessage);
        headerError.processedQtr = true;
      }
    }
    if (
      (!claimSelectByFilter?.rebateProgramCd ||
        claimSelectByFilter.rebateProgramCd === '-1') &&
      (!userDefaults?.rebateProgramCd ||
        userDefaults.rebateProgramCd === '-1')
    ) {
      errorMessages.add('Rebate Program is required.');
      headerError.rebateProgramError = true;
    }
    if (
      claimCategoryCode === '-1' ||
      !claimCategoryCode ||
      (Array.isArray(claimCategoryCode) &&
        claimCategoryCode.length === 0)
    ) {
      errorMessages.add('Claim Category Code is required.');
      headerError.claimCategoryError = true;
    }
    const providerId =
      claimSelectByFilter?.providerId?.trim();

    const providerType =
      claimSelectByFilter?.providerIdTypeCd;

    if (
      (providerType && !providerId) ||
      (!providerType && providerId)
    ) {
      errorMessages.add(
        'Please enter Provider ID Type with Provider.'
      );

      headerError.providerError = true;
    }
    if (
      !invoiceSelected?.invoiced &&
      !invoiceSelected?.nonInvoiced
    ) {
      errorMessages.add(
        'You must check one of the invoice check boxes.'
      );
    }
    if (errorMessages.size > 0) {
      setError(headerError);
      dispatch(
        setClaimErrorPopupMessage([...errorMessages])
      );
      return false;
    }
    setError({});
    dispatch(setClaimErrorPopupMessage(null));
    return true;
  };


const handleViewDetailsClick = async () => {
  dispatch(setEditedRows([]));

  dispatch(
    setNoOfUnitsSearchScreenObj({
      ...searchScreenReduxObj,
      isibwdndc: false,
      isibwdclaim: false,
    })
  );

  const isValid = checkCondition();

  if (!isValid) return;

  if (claimDetailsTableData.length === 0) {
    dispatch(setClaimErrorPopupMessage(['You have not selected any NDCs.']));
    handleScrollToEvent();
    return;
  }

  if (claimDetailsTableData.length > 1000) {
    setConfirmAction(true);
    return;
  }

  dispatch(searchClaimByNDCNu(true, false));

  dispatch(
    getOverrideDefaultData({
      planTypeCd: userDefaults?.planTypeCd,
      rebateProgramCd: claimSelectByFilter?.rebateProgramCd,
    })
  );
};



  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);

  useEffect(() => {
    resetFilters();
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, claimDetailsTableData]);

  const onSelectionChanged = useCallback(() => {
    dispatch(setClaimDetailsTableRowSelected(gridApi.getSelectedRows()));
  }, [gridApi]);
  return (
    <>
      {!fullScreen && (
        <div className="d-flex align-items-center justify-content-end">
          <Button
            className="btn btn-success btn-view"
            onClick={() => handleViewDetailsClick()}
          >
            <SVGComponent iconName="Icon-view" />
            View Claim Detail
          </Button>
        </div>
      )}
      <TableFilterHeader
        gridApi={gridApi}
        columnApi={columnApi}
        childRef={childRef}
        showFullScreen={showFullScreen}
        applyFilter={applyFilter}
        fullScreen={fullScreen}
        setFullScreen={setFullScreen}
        showHistory={false}
        fileName="NDC Details"
        resetFilterFunc={resetFilters}
        className="mt-2 mb-1 border-bottom"
      />
      <div className="table-container eightRecords">
        <Grid
          gridHeight={fullScreen ? '100vh' : 350}
          ref={childRef}
          rowData={claimDetailsTableData}
          columnDefs={NDC_DRUG_TABLEHAD}
          defaultCol={{ editable: false }}
          onGridReady={onGridReady}
          rowSelection="multiple"
          isScrollOn
          onSelectionChanged={onSelectionChanged}
          frameworkComponents={{
            ndcComponent: NDCColumnCustomComponent,
            nameRenderNdcDrugName: (cellInfo) => {
              const name = cellInfo.data && cellInfo.data.drugName;
              if (name && name.length > 21) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
          }}
          onFilterChanged={(e) => {
            setTableCount(e.api.getDisplayedRowCount());
            if (
              (e.api.getFilterModel() && Object.keys(e.api.getFilterModel()))
                .length > 0
            ) {
              setApplyFilter(true);
            } else {
              setApplyFilter(false);
            }
          }}
        />
        <p className="total-results">
          Total Results: <b>{tableCount?.toLocaleString('en-US')}</b>
        </p>
      </div>
      <CommonModal
        open={confirmAction}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => {
          dispatch(searchClaimByNDCNu(true, true));
          setConfirmAction(false);
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setConfirmAction(false)}
        modalTitle="Confirmation Dialog"
        childrenComponent={constantMessageData.NDC_LIMIT_TO_1000}
      />
    </>
    
  );
};

export default ClaimsDetailsTable;
